import { http, HttpResponse, delay } from 'msw'
import { fakeGiftCards, fakeGiftCardView } from '../fake-data/fake-gift-cards'
import { fakeGiftCardJournal } from '../fake-data/fake-gift-card-journal'

export const giftCard = [
  http.get('/api/giftCards', async () => {
    await delay(900)

    return HttpResponse.json({ list: fakeGiftCards, total: 1180, page: 1, pageCount: 12 })
  }),

  http.get('/api/giftCards/:id', async () => {
    await delay(300)

    return HttpResponse.json(fakeGiftCardView)
  }),

  http.get('/api/giftCards/:id/getPaymentLink', async () => {
    await delay(300)

    return HttpResponse.json({
      paymentLink:
        'https://pay.alfabank.ru/payment/merchants/ecom2/payment_ru.html?mdOrder=4db14ca5-ec33-7632-b778-b1ba04440ea3'
    })
  }),

  http.post('/api/giftCards', async () => {
    await delay(300)

    return HttpResponse.json({
      id: 1,
      paymentLink:
        'https://pay.alfabank.ru/payment/merchants/ecom2/payment_ru.html?mdOrder=4db14ca5-ec33-7632-b778-b1ba04440ea3'
    })
  }),

  http.delete('/api/giftCards/:id', async () => {
    await delay(300)

    return HttpResponse.json(undefined, { status: 204 })
  }),

  http.patch('/api/giftCards/:id/editStaffComment', async () => {
    await delay(300)

    return HttpResponse.json(undefined, { status: 204 })
  }),

  http.patch('/api/giftCards/:id/editStatus', async () => {
    await delay(300)

    return HttpResponse.json(undefined, { status: 204 })
  }),

  http.patch('/api/giftCards/:id/editPaymentStatus', async () => {
    await delay(300)

    return HttpResponse.json(undefined, { status: 204 })
  }),

  http.get('/api/giftCards/:id/journal', async () => {
    await delay(300)

    return HttpResponse.json(fakeGiftCardJournal)
  }),

  http.post('/api/giftCards/:id/redeem', async () => {
    await delay(300)

    return HttpResponse.json(undefined, { status: 204 })
  })
]
